function get(name) {
  return null;
}
function getEnforcing(name) {
  return null;
}
export {
  get,
  getEnforcing
};
//# sourceMappingURL=TurboModuleRegistry.js.map
